module.exports = __webpack_public_path__ + "static/media/pipe.1bc1a907.svg";